<template>
  <div
    :id="hash+'-container'"
    v-click-outside="close"
    :class="['fake-select', 'separator']"
    :style="{width: selectWidth}"
  >
    <div
      :id="hash"
      :class="{'active-selection': open}"
      class="fake-select__button d-flex justify-content-between"
      @click="open=!open"
    >
      <div class="mr-1 text-nowrap font-weight-bold">
        {{ name }}:
      </div>
      <div class="d-flex justify-content-end">
        <div class="text-nowrap">
          {{ selectedValue }}
        </div>
        <div class="ml-2">
          <font-awesome-icon icon="chevron-down" />
        </div>
      </div>
    </div>
    <b-popover
      :target="hash"
      triggers="click blur"
      :placement="sortByTooltipPlacement"
      :show.sync="open"
      :custom-class="'fake-select__options'"
      :container="hash+'-container'"
    >
      <template v-slot:title />
      <slot>
        <div
          v-for="(item, key) in options"
          :key="key"
          class="fake-select__options__item"
          @click.prevent.stop="select(item)"
        >
          {{ item.text }}
        </div>
      </slot>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: ['name', 'options', 'value', 'tooltipPlacement'],
  data: function () {
    return {
      selected: {
        text: 'None',
      },
      open: false,
      hash: null,
      optionsWidth: null,
    };
  },
  computed: {
    selectedValue: function () {
      return this.selected.text;
    },
    selectWidth: function () {
      return (this.optionsWidth !== null) ? this.optionsWidth + 'px' : 'auto';
    },
    sortByTooltipPlacement: function () {
      return this.tooltipPlacement ?? 'bottom';
    }
  },
  methods: {
    select: function (value) {
      this.selected = value;
      this.$emit('input', value.value);
      this.close();
    },
    close: function () {
      this.open = false;
    },
    setSelected: function (value) {
      let selected = undefined;
      if (this.options) {
        selected = this.options.find((option) => option.value === value);
      }
      this.selected = selected !== undefined ? selected : (value === null) ? {
        value: null,
        text: this.$t('Do not filter')
      } : {value: null, text: value};
    }
  },
  watch: {
    value: function (value) {
      this.setSelected(value);
    },
    options: function (value) {
      if (Array.isArray(value) && value.length > 0) {
        this.selected = value[0];
      }
    },
  },
  created: function () {

    if (Array.isArray(this.options) && this.options.length > 0) {
      this.setSelected((this.value) ? this.value : this.options[0].value);
    } else {
      this.setSelected(this.value);
    }
    this.hash = this.name.split('').reduce((a, b) => {
      // eslint-disable-next-line no-param-reassign
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a
    }, 0).toString();
  },
}
</script>

<style scoped lang="scss">
  .fake-select {
    outline: none;
    width: auto;
    min-width: 135px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 5px 10px;
    margin-left: 1rem;

    &__button {
      cursor: pointer;
    }

    &__options {
      max-width: none !important;

      &::v-deep {
        .popover-body {
          padding: 0;
        }
      }

      &__item {
        padding: 15px 20px;
        cursor: pointer;

        &:hover {
          background-color: $filter-item-hover;
        }
      }
    }
  }

  ::v-deep {
    .popover {
      z-index: 11;
    }
  }

  .buy-leads {
    .fake-select {
      .popover {
        @media only screen and (min-width: 1660px) {
          top: 21px !important;
        }
        @media only screen and (max-width: 1559px) {
          top: 12px !important;
        }
      }
    }
  }
  .my-leads {
    .fake-select {
      .popover {
        @media only screen and (min-width: 1490px) {
          top: 22px !important;
        }
        @media only screen and (max-width: 1489px) {
          top: 23px !important;
        }
      }
    }
  }

  .popover {
    top: 20px !important;
    .arrow {
      left: 0 !important;
      right: 0 !important;
      margin: 0 auto;
    }
  }

  @include media-breakpoint-up(xl) {
    .active-selection {
      position: relative;

      &:before {
        content: "\200C";
        position: absolute;
        height: 2px;
        background: $theme-primary;
        width: 100%;
      }
    }
  }

  .active-selection {
    &:before {
      bottom: -6px;
    }
  }

</style>
